var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})]),_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.options},on:{"vdropzone-success":_vm.vdropzone_success_handler},model:{value:(_vm.fotos),callback:function ($$v) {_vm.fotos=$$v},expression:"fotos"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }